/** Personalization fields merged into mail template variables at send time. */

export type MailUserContextInput = {
  email?: string | null;
  profile?: {
    displayName?: string | null;
    username?: string | null;
  } | null;
};

export function buildMailUserContext(input: MailUserContextInput): Record<string, string> {
  const rawDisplay = input.profile?.displayName?.trim();
  const rawUsername = input.profile?.username?.trim();
  const displayName = rawDisplay || rawUsername || 'there';
  const firstName = displayName.split(/\s+/)[0] || displayName;
  const username = rawUsername ? `@${rawUsername.replace(/^@+/, '')}` : '';
  const email = input.email?.trim() ?? '';

  return {
    displayName,
    firstName,
    fullName: rawDisplay || displayName,
    email,
    username,
  };
}

/** User context first; event-specific variables override when explicitly provided. */
export function mergeMailVariables(
  userContext: Record<string, unknown>,
  eventVariables: Record<string, unknown>,
): Record<string, unknown> {
  return { ...userContext, ...eventVariables };
}
